import React from 'react';
import { useFela } from '../..';
import { WithDmId } from '../../utils/BaseProps';
import { Style } from '../../Theme';

type FormProps = WithDmId & {
  /**
   * Child-Elemente
   */
  children: React.ReactNode;
  /**
   * String, der als name Attribut des form Elements verwendet wird.
   */
  name?: string;
  /**
   * Objekt, um das Styling des form Elements anzupassen.
   */
  style?: React.CSSProperties;
  [otherProp: string]: any;
};

interface FormStyleProps {
  theme: any;
}

export function defaultStyle({ theme }: FormStyleProps): Style {
  return {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 auto',
  };
}

export default function Form({
  children,
  dmId = 'dm-form',
  style,
  name,
  ...otherProps
}: FormProps): React.ReactElement {
  const { css } = useFela({});
  const className = css(defaultStyle, style);

  return (
    <form
      method="post"
      data-designsystem
      data-dmid={dmId}
      className={className}
      name={name}
      {...otherProps}>
      {children}
    </form>
  );
}
